import { BasicData } from './basic-data.js';

/**
 * SimpleData
 *
 * This will extend Data to add a simple data object
 * that doesn't allow deep nested data.
 *
 * @class
 * @augments BasicData
 */
export class SimpleData extends BasicData
{

}